import CloseIcon from '@mui/icons-material/Close';
import {
  Autocomplete,
  Button,
  FormHelperText,
  IconButton,
  Input,
  MenuItem,
  Select,
  Switch,
  TextField,
} from '@mui/material';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import CustomBrandsModal from '../../components/CustomBrands';
import { errorToast } from '../../helpers';
import { MasterData } from '../../types/General';
import { STEERING_TYPE, VEHICLE_CONDITION } from '../../utils/enums';
import { UploadMedia } from '../../utils/mediaUpload';
import { isNumber, isValidInput } from '../../utils/validations';

type Image_info = {
  make: string;
  model: string;
  color: string;
};

const fleetOptions = [
  { id: 1, name: 'Collision Damage' },
  { id: 2, name: 'Interior Damage' },
  { id: 3, name: 'Environmental Damage' },
  { id: 4, name: 'Wear & Tear Damage' },
  { id: 5, name: 'Mechanical Damage' },
  { id: 6, name: 'Vandalism & Theft Damage' },
  { id: 7, name: 'Tire & Wheel Damage' },
];
const carFeatures = [
  { id: 1, name: 'Auto Gear', icon: '⚙️' },
  { id: 2, name: '5 Seater', icon: '🪑' },
  { id: 3, name: 'Camera', icon: '📷' },
  { id: 4, name: 'V6 Engine', icon: '🛠️' },
  { id: 5, name: 'Black Colour', icon: '🎨' },
  { id: 6, name: 'Sensors', icon: '📡' },
  { id: 7, name: 'LCD', icon: '📺' },
];

type CarFormProps = {
  formik: any;
  masterData: MasterData | undefined;
  fleetDamage: any;
  setFleetDamage: any;
  features: any;
  setFeatures: any;
  carImages: string[];
  setCarImages: Dispatch<SetStateAction<string[]>>;
  coverImage: string;
  setCoverImage: Dispatch<SetStateAction<string>>;
  accidentHistory: boolean;
  setAccidentHistory: Dispatch<SetStateAction<boolean>>;
  imageInfo: Image_info;
  setImageInfo: Dispatch<SetStateAction<Image_info>>;
};

const CarForm = ({
  formik,
  masterData,
  features,
  fleetDamage,
  setFeatures,
  setFleetDamage,
  carImages,
  coverImage,
  setCarImages,
  setCoverImage,
  accidentHistory,
  setAccidentHistory,
  imageInfo,
  setImageInfo,
}: CarFormProps) => {
  // const [imageInfo, setImageInfo] = useState<Image_info>({
  //   color: '',
  //   make: '',
  //   model: '',
  // });
  const [open, setOpen] = useState<boolean>(false);

  const handleCloseModal = () => {
    setOpen(false);
    formik.setFieldValue('brandId', 'default');
  };

  const CompareImage = (obj: any): boolean => {
    const keysToCompare: (keyof Image_info)[] = [
      'color',
      'make',
      'model',
      // "year",
    ];

    return keysToCompare.every((key) => {
      const a = obj[key];
      const b = imageInfo[key];

      if (typeof a === 'string' && typeof b === 'string') {
        return a.toLowerCase() === b.toLowerCase();
      }

      return a === b;
    });
  };

  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const handleCarUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target?.files || [];
    // if (Array.from(files || []).length > 20) {
    //   errorToast("Max limit is upto 20 images");
    //   event.target.value = "";
    //   return;
    // }

    // Check if files exist
    if (!files.length) {
      errorToast('No images selected');
      return;
    }

    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    const uploadedImages: string[] = [...(carImages || [])];
    const invalidFiles = Array.from(files || []).filter(
      (file) => !allowedTypes.includes(file.type)
    );

    for (const file of files) {
      // Validate file type
      if (invalidFiles.length > 0) {
        errorToast('Inavlid  type');
        event.target.value = '';
        return;
      }
      if (uploadedImages?.length >= 4) {
        errorToast("You can't add more than 5 images including cover image.");
        return;
      }
      // Upload image
      const res = await UploadMedia(file, true);
      if (res?.statusCode === 200) {
        const obj = {
          make: res?.data?.vehicleDetails?.make || '',
          model: res?.data?.vehicleDetails?.model || '',
          // year: res?.data?.vehicleDetails?.year,
          color: res?.data?.vehicleDetails?.color || '',
        };

        if (res?.data?.vehicleDetails?.isVehicle === 'No') {
          errorToast('Please Upload a valid image');
        } else if (res?.data?.vehicleDetails?.view !== 'Exterior') {
          uploadedImages.push(res?.data?.image);
        } else {
          if (imageInfo.color == '' && imageInfo.model == '' && imageInfo.make == '') {
            uploadedImages.push(res?.data?.image);
            setImageInfo(obj);
            setCarImages(uploadedImages);
          } else if (CompareImage(obj)) {
            uploadedImages.push(res?.data?.image);
            setImageInfo(obj);
            setCarImages(uploadedImages);
          } else {
            errorToast('Car image mismatch. Please check brand/model.');
          }
        }
      } else {
        errorToast(`${'Failed to upload:'} ${file.name}`);
      }
    }

    // Update formik values with uploaded images
    setCarImages(uploadedImages);
    // const resArray = await Promise.all(
    //   Array.from(files || []).map(async (file) => {
    //     if (allowedTypes.includes(file.type)) {
    //       return UploadMedia(file, true);
    //     }
    //   })
    // );

    // resArray.map((res) => {
    //   if (res?.statusCode === 200) {
    //     setCarImages((prevImages) => [...prevImages, res?.data?.image]);

    //     event.target.value = '';
    //   } else {
    //     event.target.value = '';
    //   }
    // });
  };

  const handleCoverUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target;
    const file = files?.files?.length ? files?.files[0] : '';
    // if (Array.from(files || []).length > 20) {
    //   errorToast("Max limit is upto 20 images");
    //   event.target.value = "";
    //   return;
    // }
    if (
      file &&
      file.type &&
      file.type !== 'image/jpeg' &&
      file.type !== 'image/jpg' &&
      file.type !== 'image/png'
    ) {
      errorToast('Invalid image type');
      return;
    }

    // const images = await UploadMedia(file);
    // if (images?.statusCode === 200) {
    //   setCoverImage(images?.data?.image);
    //   event.target.value = '';
    // }

    const res = await UploadMedia(file, true);
    if (res?.statusCode === 200) {
      const obj = {
        make: (res?.data?.vehicleDetails?.make as string) || '',
        model: (res?.data?.vehicleDetails?.model as string) || '',
        // year: res?.data?.vehicleDetails?.year,
        color: (res?.data?.vehicleDetails?.color as string) || '',
      };

      // setAiResponse(obj);
      if (res?.data?.vehicleDetails?.isVehicle === 'No') {
        errorToast('Please Upload a valid image');
      }
      if (res?.data?.vehicleDetails?.view !== 'Exterior') {
        errorToast('Cover Image must be a Exterior image.');
      } else {
        if (imageInfo.color == '' && imageInfo.model == '' && imageInfo.make == '') {
          setCoverImage(res?.data?.image);
          setImageInfo(obj);
        } else if (CompareImage(obj)) {
          setCoverImage(res?.data?.image);
          setImageInfo(obj);
        } else {
          errorToast('Car image mismatch. Please check brand/model.');
          formik.setFieldValue('coverImage', '');
        }
      }
    } else {
      errorToast(res?.message);
    }
  };

  const handleRemove = (index: number) => {
    const updatedImages = carImages.filter((_, i) => i !== index);
    setCarImages(updatedImages);
    if (updatedImages?.length === 0) {
      formik.setFieldValue('brandId', 'default');
      formik.setFieldValue('exterior', 'default');
      setImageInfo({
        make: '',
        color: '',
        model: '',
      });
    }
  };

  useEffect(() => {
    if (formik.values.brandId == 'other') {
      setOpen(true);
      formik.setFieldValue('brandId', 'default');
    }
  }, [formik.values.brandId]);

  return (
    <>
      {/* Car Image */}
      <div className="control_group w_50">
        <label>Image</label>
        <div className="upload_box_bnr">
          {carImages?.length
            ? carImages.map((image, index) => (
                <label key={index}>
                  <IconButton className="crossIcon" onClick={() => handleRemove(index)}>
                    <CloseIcon />
                  </IconButton>
                  <figure>
                    <img src={image || '/static/images/picture.png'} alt="Upload" />
                  </figure>
                </label>
              ))
            : null}

          {carImages?.length < 4 ? (
            <label>
              <figure>
                <img src={'/static/images/picture.png'} alt="Upload" />
              </figure>
              <IconButton className="uploadIcon">
                <label htmlFor="icon-button-file">
                  <Button component="span" className="upload_image_btn">
                    <img src="/static/images/edit2_icon.svg" alt="Upload" />
                    <Input
                      sx={{ display: 'none' }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: 'image/png,image/jpeg',
                        multiple: true,
                      }}
                      onChange={(e: any) => {
                        handleCarUpload(e);
                        e.target.value = null;
                      }}
                    />
                  </Button>
                </label>
              </IconButton>
            </label>
          ) : null}
        </div>
      </div>
      {/* Cover Image */}
      <div className="control_group w_100">
        <label>Cover Image</label>
        <div className="upload_box_bnr">
          <label>
            {coverImage && (
              <IconButton className="crossIcon" onClick={() => setCoverImage('')}>
                <CloseIcon />
              </IconButton>
            )}
            <figure>
              <img src={coverImage ? coverImage : '/static/images/picture.png'} alt="Upload" />
            </figure>
            <IconButton className="uploadIcon">
              <label htmlFor="icon-button-file-cover">
                <Button component="span" className="upload_image_btn">
                  <img src="/static/images/edit2_icon.svg" alt="Upload" />
                  <Input
                    sx={{ display: 'none' }}
                    id="icon-button-file-cover"
                    type="file"
                    inputProps={{
                      accept: 'image/png,image/jpeg',
                    }}
                    onChange={(e: any) => {
                      handleCoverUpload(e);
                      e.target.value = null;
                    }}
                  />
                </Button>
              </label>
            </IconButton>
          </label>
        </div>
      </div>
      {/* Car Condition */}
      <div className="control_group w_50">
        <label>Car Condition</label>
        <Select
          fullWidth
          labelId="condition"
          name="condition"
          value={formik.values.condition}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.condition && Boolean(formik.errors.condition)}
        >
          <MenuItem disabled value="default">
            Car Condition
          </MenuItem>

          <MenuItem value={VEHICLE_CONDITION.NEW}>New</MenuItem>
          <MenuItem value={VEHICLE_CONDITION.OLD}>Old</MenuItem>
        </Select>
        <FormHelperText error>{formik.touched.condition && formik.errors.condition}</FormHelperText>
      </div>

      {/* Title */}
      <div className="control_group w_50">
        <label>Title</label>
        <TextField
          variant="outlined"
          placeholder="Title"
          fullWidth
          hiddenLabel
          className="text_field"
          name="title"
          id="title"
          inputProps={{ maxLength: 80 }}
          value={formik.values.title}
          onChange={(val) => {
            if (isValidInput(val.target.value)) {
              formik.handleChange(val);
            }
          }}
          onBlur={formik.handleBlur}
          helperText={formik.touched.title && formik.errors.title}
        />
      </div>
      {/* Brand */}
      <div className="control_group w_50">
        <label>Select Brand</label>
        <Select
          fullWidth
          labelId="brandId"
          name="brandId"
          value={masterData?.brand?.length ? formik.values.brandId : ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.brandId && Boolean(formik.errors.brandId)}
        >
          <MenuItem disabled value="default">
            Select Brand
          </MenuItem>
          <MenuItem value="other">+ Add New Brand</MenuItem>
          {masterData?.brand?.length
            ? masterData?.brand?.map((item, i: number) => {
                const disabled = item?.name.toLowerCase() !== imageInfo.make.toLowerCase();

                return (
                  <MenuItem
                    key={i}
                    disabled={disabled}
                    value={masterData?.brand?.length ? item?._id : ''}
                  >
                    {item?.name || '-'}
                  </MenuItem>
                );
              })
            : 'No brands found'}
        </Select>
        <FormHelperText error>{formik.touched.brandId && formik.errors.brandId}</FormHelperText>
      </div>
      {/* Model */}
      <div className="control_group w_50">
        <label>Select Model</label>
        <Select
          fullWidth
          labelId="modelId"
          name="modelId"
          value={masterData?.vehicleModel?.length ? formik.values.modelId : ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.modelId && Boolean(formik.errors.modelId)}
        >
          <MenuItem disabled value="default">
            Select Model
          </MenuItem>
          {masterData?.vehicleModel?.length
            ? masterData?.vehicleModel?.map((item, i: number) => {
                return (
                  <MenuItem key={i} value={masterData?.vehicleModel?.length ? item?._id : ''}>
                    {item?.name || '-'}
                  </MenuItem>
                );
              })
            : 'No models found'}
        </Select>
        <FormHelperText error>{formik.touched.modelId && formik.errors.modelId}</FormHelperText>
      </div>
      <div className="control_group w_50">
        <label>Number of Wheels</label>
        <TextField
          variant="outlined"
          placeholder="Number of wheels"
          fullWidth
          hiddenLabel
          className="text_field"
          name="wheel"
          id="wheel"
          inputProps={{ maxLength: 4 }}
          value={formik.values.wheel}
          onChange={(val) => {
            if (isNumber(val.target.value)) {
              formik.handleChange(val);
            }
          }}
          onBlur={formik.handleBlur}
          helperText={formik.touched.wheel && formik.errors.wheel}
        />
      </div>
      {/* Body Type */}
      <div className="control_group w_50">
        <label>Select Body Type</label>
        <Select
          fullWidth
          labelId="bodyTypeId"
          name="bodyTypeId"
          value={masterData?.bodyType?.length ? formik.values.bodyTypeId : ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.bodyTypeId && Boolean(formik.errors.bodyTypeId)}
        >
          <MenuItem disabled value="default">
            Select Body Type
          </MenuItem>
          {masterData?.bodyType?.length
            ? masterData?.bodyType?.map((item, i: number) => {
                return (
                  <MenuItem key={i} value={masterData?.bodyType?.length ? item?._id : ''}>
                    {item?.name || '-'}
                  </MenuItem>
                );
              })
            : 'No body type found'}
        </Select>
        <FormHelperText error>
          {formik.touched.bodyTypeId && formik.errors.bodyTypeId}
        </FormHelperText>
      </div>

      <div className="control_group w_50">
        <label>Select Number of cylinder</label>
        <Select
          fullWidth
          labelId="numberofCylinder"
          name="numberofCylinder"
          value={formik.values.numberofCylinder}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.numberofCylinder && Boolean(formik.errors.numberofCylinder)}
        >
          <MenuItem disabled value="">
            Select Number of cylinder
          </MenuItem>
          {Array.from({ length: 13 }, (_, index) => (
            <MenuItem key={index} value={index + 1}>
              {index === 12 ? '12+' : `${index + 1}`}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText error>
          {formik.touched.numberofCylinder && formik.errors.numberofCylinder}
        </FormHelperText>
      </div>

      {/* Mileage */}
      <div className="control_group w_50">
        <label>Mileage</label>
        <TextField
          variant="outlined"
          placeholder="Mileage"
          fullWidth
          hiddenLabel
          className="text_field"
          name="mileage"
          id="mileage"
          inputProps={{ maxLength: 5 }}
          value={formik.values.mileage}
          onChange={(val) => {
            if (isNumber(val.target.value)) {
              formik.handleChange(val);
            }
          }}
          onBlur={formik.handleBlur}
          helperText={formik.touched.mileage && formik.errors.mileage}
        />
      </div>

      {/* GCC */}
      <div className="control_group w_50">
        <label>Select GCC</label>
        <Select
          fullWidth
          labelId="gccId"
          name="gccId"
          value={masterData?.gcc?.length ? formik.values.gccId : ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.gccId && Boolean(formik.errors.gccId)}
        >
          <MenuItem disabled value="default">
            Select GCC
          </MenuItem>

          {masterData?.gcc?.length
            ? masterData?.gcc?.map((item, i: number) => {
                return (
                  <MenuItem key={i} value={masterData?.gcc?.length ? item?._id : ''}>
                    {item?.name || '-'}
                  </MenuItem>
                );
              })
            : 'No gcc found'}
        </Select>
        <FormHelperText error>{formik.touched.gcc && formik.errors.gcc}</FormHelperText>
      </div>
      {/* Fuel Type */}
      <div className="control_group w_50">
        <label>Select Fuel Type</label>
        <Select
          fullWidth
          labelId="fuelTypeId"
          name="fuelTypeId"
          value={masterData?.fuelType?.length ? formik.values.fuelTypeId : ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.fuelTypeId && Boolean(formik.errors.fuelTypeId)}
        >
          <MenuItem disabled value="default">
            Select Fuel Type
          </MenuItem>
          {masterData?.fuelType?.length
            ? masterData?.fuelType?.map((item, i: number) => {
                return (
                  <MenuItem key={i} value={masterData?.fuelType?.length ? item?._id : ''}>
                    {item?.name || '-'}
                  </MenuItem>
                );
              })
            : 'No fuel type data found'}
        </Select>
        <FormHelperText error>{formik.touched.fuelType && formik.errors.fuelType}</FormHelperText>
      </div>
      {/* Seats */}
      <div className="control_group w_50">
        <label>Select Seats</label>
        <Select
          fullWidth
          labelId="seat"
          name="seat"
          value={formik.values.seat}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.seat && Boolean(formik.errors.seat)}
        >
          <MenuItem disabled value="default">
            Select Seats
          </MenuItem>
          <MenuItem value={1}>1 Seater </MenuItem>
          <MenuItem value={2}>2 Seater</MenuItem>
          <MenuItem value={3}>3 Seater</MenuItem>
          <MenuItem value={4}>4 Seater</MenuItem>
          <MenuItem value={5}>5 Seater</MenuItem>
          <MenuItem value={6}>6 Seater</MenuItem>
          <MenuItem value={7}>7 Seater </MenuItem>
          <MenuItem value={8}>7 Seater </MenuItem>
          <MenuItem value={9}>8+ Seater</MenuItem>
        </Select>
        <FormHelperText error>{formik.touched.seat && formik.errors.seat}</FormHelperText>
      </div>
      {/* Doors */}
      <div className="control_group w_50">
        <label>Select Doors</label>
        <Select
          fullWidth
          labelId="door"
          name="door"
          value={formik.values.door}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.door && Boolean(formik.errors.door)}
        >
          <MenuItem disabled value="default">
            Select Doors
          </MenuItem>
          <MenuItem value={2}>2 </MenuItem>
          <MenuItem value={3}>3 </MenuItem>
          <MenuItem value={4}>4 </MenuItem>
          <MenuItem value={5}>5 </MenuItem>
          <MenuItem value={6}>6 </MenuItem>
          <MenuItem value={7}>7 </MenuItem>
          <MenuItem value={8}>7 </MenuItem>
          <MenuItem value={9}>8+ </MenuItem>
        </Select>
        <FormHelperText error>{formik.touched.door && formik.errors.door}</FormHelperText>
      </div>
      {/* Steering Type */}
      <div className="control_group w_50">
        <label>Steering Type</label>
        <Select
          fullWidth
          labelId="steeringSide"
          name="steeringSide"
          value={formik.values.steeringSide}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.steeringSide && Boolean(formik.errors.steeringSide)}
        >
          <MenuItem disabled value="default">
            Steering Type
          </MenuItem>
          <MenuItem value={STEERING_TYPE.LEFT}>Left </MenuItem>
          <MenuItem value={STEERING_TYPE.RIGHT}>Right </MenuItem>
        </Select>
        <FormHelperText error>
          {formik.touched.steeringSide && formik.errors.steeringSide}
        </FormHelperText>
      </div>
      {/* Transmission */}
      <div className="control_group w_50">
        <label>Select Transmission Type</label>
        <Select
          fullWidth
          labelId="transmission"
          name="transmission"
          value={formik.values.transmission}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.transmission && Boolean(formik.errors.transmission)}
        >
          <MenuItem disabled value="default">
            Select Transmission Type
          </MenuItem>
          <MenuItem value={1}>Manual Transmission (c)</MenuItem>
          <MenuItem value={2}>Automatic Transmission (AT)</MenuItem>
        </Select>
        <FormHelperText error>
          {formik.touched.transmission && formik.errors.transmission}
        </FormHelperText>
      </div>
      {/*  Power */}
      <div className="control_group w_50">
        <label>Select Power</label>
        <Select
          fullWidth
          labelId="horsePowerId"
          name="horsePowerId"
          value={masterData?.horsePower?.length ? formik.values.horsePowerId : ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.horsePowerId && Boolean(formik.errors.horsePowerId)}
        >
          <MenuItem disabled value="default">
            Select Power
          </MenuItem>
          {masterData?.horsePower?.length
            ? masterData?.horsePower?.map((item, i: number) => {
                return (
                  <MenuItem key={i} value={masterData?.horsePower?.length ? item?._id : ''}>
                    {item?.name || '-'}
                  </MenuItem>
                );
              })
            : 'No power data found'}
        </Select>
        <FormHelperText error>
          {formik.touched.horsePowerId && formik.errors.horsePowerId}
        </FormHelperText>
      </div>
      {/* Engine Capacity */}
      <div className="control_group w_50">
        <label>Engine Capacity</label>

        <Select
          fullWidth
          labelId="engineCapacityId"
          name="engineCapacityId"
          value={masterData?.engineCapacity?.length ? formik.values.engineCapacityId : ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.engineCapacityId && Boolean(formik.errors.engineCapacityId)}
        >
          <MenuItem disabled value="default">
            Select Engine Capacity
          </MenuItem>
          {masterData?.engineCapacity?.length
            ? masterData?.engineCapacity?.map((item, i: number) => {
                return (
                  <MenuItem key={i} value={masterData?.engineCapacity?.length ? item?._id : ''}>
                    {item?.min} - {item?.max}
                  </MenuItem>
                );
              })
            : 'No data found'}
        </Select>
        <FormHelperText error>
          {formik.touched.engineCapacityId && formik.errors.engineCapacityId}
        </FormHelperText>
      </div>
      {/* Interior Color */}
      <div className="control_group w_50">
        <label>Select Interior Color</label>
        <Select
          fullWidth
          labelId="interior"
          name="interior"
          value={masterData?.color?.length ? formik.values.interior : ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.interior && Boolean(formik.errors.interior)}
        >
          <MenuItem disabled value="default">
            Select Interior Color
          </MenuItem>
          {masterData?.color?.length
            ? masterData?.color?.map((item, i: number) => {
                return (
                  <MenuItem key={i} value={masterData?.color?.length ? item?._id : ''}>
                    {item?.name || ''}
                  </MenuItem>
                );
              })
            : 'No data found'}
        </Select>
        <FormHelperText error>{formik.touched.interior && formik.errors.interior}</FormHelperText>
      </div>
      {/* Exterior Color */}
      <div className="control_group w_50">
        <label>Select Exterior Color</label>
        <Select
          fullWidth
          labelId="exterior"
          name="exterior"
          value={masterData?.color?.length ? formik.values.exterior : ''}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.exterior && Boolean(formik.errors.exterior)}
        >
          <MenuItem disabled value="default">
            Select Exterior Color
          </MenuItem>
          {masterData?.color?.length
            ? masterData?.color?.map((item, i: number) => {
                const disabled = item?.name.toLowerCase() !== imageInfo.color.toLowerCase();
                return (
                  <MenuItem
                    key={i}
                    disabled={disabled}
                    value={masterData?.color?.length ? item?._id : ''}
                  >
                    {item?.name || ''}
                  </MenuItem>
                );
              })
            : 'No data found'}
        </Select>
        <FormHelperText error>{formik.touched.exterior && formik.errors.exterior}</FormHelperText>
      </div>

      {/* Fleet Damage */}
      <div className="control_group w_50">
        <label>Fleet Damage</label>

        <Autocomplete
          multiple
          id="checkboxes-tags-demo"
          options={masterData?.damage || []}
          onChange={(event, newValue) => {
            setFleetDamage(newValue);
          }}
          value={fleetDamage}
          disableCloseOnSelect
          filterSelectedOptions
          limitTags={2}
          getOptionLabel={(option) => option?.name || ''}
          className="autocomplete"
          renderInput={(params) => (
            <TextField
              variant="outlined"
              hiddenLabel
              {...params}
              placeholder={fleetDamage.length === 0 ? 'Select Fleet Damage' : ''}
            />
          )}
        />
      </div>
      {/* Features */}
      <div className="control_group w_50">
        <label>Features</label>

        <Autocomplete
          multiple
          id="checkboxes-tags-demo"
          options={masterData?.feature || []}
          onChange={(event, newValue) => {
            setFeatures(newValue);
          }}
          value={features}
          disableCloseOnSelect
          filterSelectedOptions
          limitTags={2}
          getOptionLabel={(option) => option?.name || ''}
          className="autocomplete"
          renderInput={(params) => (
            <TextField
              variant="outlined"
              hiddenLabel
              {...params}
              placeholder={features.length === 0 ? 'Select Features' : ''}
            />
          )}
        />
      </div>
      {/* Price */}
      <div className="control_group w_50">
        <label>Final Price</label>
        <TextField
          variant="outlined"
          placeholder="Final Price"
          fullWidth
          hiddenLabel
          className="text_field"
          name="price"
          id="price"
          inputProps={{ maxLength: 10 }}
          value={formik.values.price}
          onChange={(val) => {
            if (isNumber(val.target.value)) {
              formik.handleChange(val);
            }
          }}
          onBlur={formik.handleBlur}
          helperText={formik.touched.price && formik.errors.price}
        />
      </div>

      {/* City */}
      <div className="control_group w_50">
        <label>City</label>
        <TextField
          variant="outlined"
          placeholder="City"
          fullWidth
          hiddenLabel
          className="text_field"
          name="city"
          id="city"
          inputProps={{ maxLength: 80 }}
          value={formik.values.city}
          onChange={(val) => {
            if (isValidInput(val.target.value)) {
              formik.handleChange(val);
            }
          }}
          onBlur={formik.handleBlur}
          helperText={formik.touched.city && formik.errors.city}
        />
      </div>
      {/* Area */}
      <div className="control_group w_50">
        <label>Area</label>
        <TextField
          variant="outlined"
          placeholder="Area"
          fullWidth
          hiddenLabel
          className="text_field"
          name="address"
          id="address"
          inputProps={{ maxLength: 100 }}
          value={formik.values.address}
          onChange={(val) => {
            if (isValidInput(val.target.value)) {
              formik.handleChange(val);
            }
          }}
          onBlur={formik.handleBlur}
          helperText={formik.touched.address && formik.errors.address}
        />
      </div>

      {/* Description */}
      <div className="control_group w_50">
        <label>Vehicle Description</label>
        <TextField
          variant="outlined"
          placeholder="Vehicle Description"
          fullWidth
          multiline
          minRows={3}
          maxRows={4}
          hiddenLabel
          className="text_field"
          name="description"
          id="description"
          inputProps={{ maxLength: 500 }}
          value={formik.values.description}
          onChange={(val) => {
            if (isValidInput(val.target.value)) {
              formik.handleChange(val);
            }
          }}
          onBlur={formik.handleBlur}
          helperText={formik.touched.description && formik.errors.description}
        />
      </div>
      {/* Accident History */}
      <div className="control_group w_50">
        <label>Accident History?</label>
        <Switch
          {...label}
          checked={accidentHistory}
          onChange={() => setAccidentHistory(!accidentHistory)}
        />
      </div>
      {accidentHistory ? (
        <div className="control_group w_50">
          <label>Accident Description</label>
          <TextField
            variant="outlined"
            placeholder=" Accident Description"
            fullWidth
            multiline
            minRows={3}
            maxRows={4}
            hiddenLabel
            className="text_field"
            name="accidentHistoryDesc"
            id="accidentHistoryDesc"
            inputProps={{ maxLength: 500 }}
            value={formik.values.accidentHistoryDesc}
            onChange={(val) => {
              if (isValidInput(val.target.value)) {
                formik.handleChange(val);
              }
            }}
            onBlur={formik.handleBlur}
            helperText={formik.touched.accidentHistoryDesc && formik.errors.accidentHistoryDesc}
          />
        </div>
      ) : null}

      <CustomBrandsModal open={open} onClose={handleCloseModal} setOpen={setOpen} />
    </>
  );
};

export default CarForm;
